import TextHighlighterService from './core/TextHighlighterService.js';
import ResponseDataLoaderService from './core/ResponseDataLoaderService';
import EventLogBridgeServiceModule from './core/EventLogBridgeService';
import ColorThemeService from './core/ColorThemeService';
import InactivityTimeoutService from './core/InactivityTimeoutService';
import HybridTimeService from './core/HybridTimeService';
import TaskSelectionService from './core/TaskSelectionService';
import DataBridgeServiceModule from './core/DataBridgeService';
import CMSDataBridgeServiceModule from './cms/CMSDataBridgeService';
import ConfigService from './core/ConfigService';
import AuthenticationBridgeServiceModule from './core/AuthenticationBridgeService';
import ErrorHandlerService from './core/ErrorHandlerService';
import NotificationService from './cms/NotificationService';
import ConfigAPIService from './core/ConfigAPIService';
import SheetLoadedService from './core/SheetLoadedService';
import ResponseAPIService from './core/ResponseAPIService';
import ObjectCacheService from './core/ObjectCacheService';
import TaskFlowService from './core/TaskFlowService';
import UserInfoService from './core/UserInfoService';
import FreezeService from './core/FreezeService';
import UniversalCanvasService from './core/UniversalCanvasService';
import IFrameAPIService from './core/IFrameAPIService';
import BrowserCheckService from './cms/BrowserCheckService';
import SheetStructureHelperService from './cms/SheetStructureHelperService';
import IAAPreferencesService from './core/IAAPreferencesService';
import LogBridgeServiceModule from './core/LogBridgeService';
import ExamSessionSelectionService from './cms/ExamSessionSelectionService';
import BridgesModule from './Bridges';
import SignalsModule from './core/SignalsService';
import CheckLoginService from './cms/CheckLoginService';
import SheetLeaveService from './core/SheetLeaveService';
import VMDetectionService from './core/VMDetectionService';
import CryptoHelperService from './cms/cryptoHelperService';
import TaskInfoService from './core/TaskInfoService';
import APIService from './core/APIService';
import ReadingTimeService from './core/ReadingTimeService';
import CMSSortableService from './cms/CMSSortableService';
import FocusRecoveredService from './core/FocusRecoveredService';
import OptionsService from './core/OptionsService';
import CompCheckBridgeService from './core/CompCheckBridgeService';
import VersioningAndLockingService from './cms/VersioningAndLockingService';
import DeleteObjectHelperService from './cms/DeleteObjectHelperService';
import CMSMediaInfoService from './cms/CMSMediaInfoService';
import ContentObjectRegistryService from './cms/ContentObjectRegistryService';
import FindObjectService from './cms/FindObjectService';
import ConsistencyDataService from './cms/ConsistencyDataService';
import ObjectInstanceRegistrationService from './core/ObjectInstanceRegistrationService';
import CMSMediaUploadService from './cms/CMSMediaUploadService';
import ValidatorService from './cms/ValidatorService';
import JsBridgeRuntimeService from './core/BridgeRuntimeService';
import TaskDataService from './core/TaskDataService';
import CountdownModel from './core/TaskCountdownService';
import RichTextEditorService from './core/RichTextEditorService';
import CopyContainerHelperService from './cms/CopyContainerHelperService.js';
import PreloadBridgeService from './core/PreloadBridgeService';
import { SessionResumeService } from './SessionResumeService.js';
import { ServiceWorkerHealthMonitor } from './ServiceWorkerHealthMonitor.js';
import { ServiceWorkerUpdateController } from './ServiceWorkerUpdateController.js';
import TelemetryBeaconService from './core/TelemetryBeaconService';

const registerServices = function(angular) {
    angular.module('assessmentFrontendServices').service('TextHighlighterService', TextHighlighterService);
    angular.module('assessmentFrontendServices').service('ResponseDataLoaderService', ResponseDataLoaderService);
    angular.module('assessmentFrontendServices').service('EventLogBridgeService', EventLogBridgeServiceModule);
    angular.module('assessmentFrontendServices').service('ColorThemeService', ColorThemeService);
    angular.module('assessmentFrontendServices').service('InactivityTimeoutService', InactivityTimeoutService);
    angular.module('assessmentFrontendServices').service('HybridTimeService', HybridTimeService);
    angular.module('assessmentFrontendServices').service('TaskSelectionService', TaskSelectionService);
    angular.module('assessmentFrontendServices').service('DataBridgeService', DataBridgeServiceModule);
    angular.module('assessmentFrontendServices').service('CMSDataBridgeService', CMSDataBridgeServiceModule);
    angular.module('assessmentFrontendServices').service('$config', ConfigService);
    angular.module('assessmentFrontendServices').service('AuthenticationBridgeService', AuthenticationBridgeServiceModule);
    angular.module('assessmentFrontendServices').service('ErrorHandlerService', ErrorHandlerService);
    angular.module('assessmentFrontendServices').service('NotificationService', NotificationService);
    angular.module('assessmentFrontendServices').service('ConfigAPIService', ConfigAPIService);
    angular.module('assessmentFrontendServices').service('SheetLoadedService', SheetLoadedService);
    angular.module('assessmentFrontendServices').service('ResponseAPIService', ResponseAPIService);
    angular.module('assessmentFrontendServices').service('$objectCache', ObjectCacheService);
    angular.module('assessmentFrontendServices').service('TaskFlowService', TaskFlowService);
    angular.module('assessmentFrontendServices').service('UserInfoService', UserInfoService);
    angular.module('assessmentFrontendServices').service('FreezeService', FreezeService);
    angular.module('assessmentFrontendServices').service('UniversalCanvasService', UniversalCanvasService);
    angular.module('assessmentFrontendServices').service('IFrameAPIService', IFrameAPIService);
    angular.module('assessmentFrontendServices').service('BrowserCheckService', BrowserCheckService);
    angular.module('assessmentFrontendServices').service('SheetStructureHelperService', SheetStructureHelperService);
    angular.module('assessmentFrontendServices').service('IAAPreferencesService', IAAPreferencesService);
    angular.module('assessmentFrontendServices').service('LogBridgeService', LogBridgeServiceModule);
    angular.module('assessmentFrontendServices').service('ExamSessionSelectionService', ExamSessionSelectionService);
    angular.module('assessmentFrontendServices').service('$bridges', BridgesModule);
    angular.module('assessmentFrontendServices').service('$signals', SignalsModule);
    angular.module('assessmentFrontendServices').service('CheckLoginService', CheckLoginService);
    angular.module('assessmentFrontendServices').service('SheetLeaveService', SheetLeaveService);
    angular.module('assessmentFrontendServices').service('VMDetectionService', VMDetectionService);
    angular.module('assessmentFrontendServices').service('CryptoHelperService', CryptoHelperService);
    angular.module('assessmentFrontendServices').service('TaskInfoService', TaskInfoService);
    angular.module('assessmentFrontendServices').service('APIService', APIService);
    angular.module('assessmentFrontendServices').service('ReadingTimeService', ReadingTimeService);
    angular.module('assessmentFrontendServices').service('CMSSortableService', CMSSortableService);
    angular.module('assessmentFrontendServices').service('FocusRecoveredService', FocusRecoveredService);
    angular.module('assessmentFrontendServices').service('$options', OptionsService);
    angular.module('assessmentFrontendServices').service('CompCheckBridgeService', CompCheckBridgeService);
    angular.module('assessmentFrontendServices').service('VersioningAndLockingService', VersioningAndLockingService);
    angular.module('assessmentFrontendServices').service('DeleteObjectHelperService', DeleteObjectHelperService);
    angular.module('assessmentFrontendServices').service('CMSMediaInfoService', CMSMediaInfoService);
    angular.module('assessmentFrontendServices').service('ContentObjectRegistryService', ContentObjectRegistryService);
    angular.module('assessmentFrontendServices').service('FindObjectService', FindObjectService);
    angular.module('assessmentFrontendServices').service('ConsistencyDataService', ConsistencyDataService);
    angular.module('assessmentFrontendServices').service('ObjectInstanceRegistrationService', ObjectInstanceRegistrationService);
    angular.module('assessmentFrontendServices').service('CMSMediaUploadService', CMSMediaUploadService);
    angular.module('assessmentFrontendServices').service('ValidatorService', ValidatorService);
    angular.module('assessmentFrontendServices').service('BridgeRuntimeService', JsBridgeRuntimeService);
    angular.module('assessmentFrontendServices').service('TaskDataService', TaskDataService);
    angular.module('assessmentFrontendServices').service('TaskCountdownService', CountdownModel);
    angular.module('assessmentFrontendServices').service('CopyContainerHelperService', CopyContainerHelperService);
    angular.module('assessmentFrontendServices').service('PreloadBridgeService', PreloadBridgeService);
    angular.module('assessmentFrontendServices').service('SessionResumeService', SessionResumeService);
    angular.module('assessmentFrontendServices').service('ServiceWorkerHealthMonitor', ServiceWorkerHealthMonitor);
    angular.module('assessmentFrontendServices').service('ServiceWorkerUpdateController', ServiceWorkerUpdateController);
    angular.module('assessmentFrontendServices').service('TelemetryBeaconService', TelemetryBeaconService);
};

export default registerServices;
